import "./global-styles.scss";
import { RootProvider } from "./providers";
import { AppRouter } from "./router";

export function App() {
  return (
    <RootProvider>
      <AppRouter />
    </RootProvider>
  );
}
